import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OrgMenuItem',
    props: {
        org: null,
        isCurrent: {
            type: Boolean
        },
        isAdmin: {
            type: Boolean
        }
    },
    emits: [
        "hover",
        "org-click",
        "settings-click"
    ],
    setup: function setup(__props) {
        return {
            __sfc: true
        };
    }
});
